import { combine } from 'effector'
import { model as i18n } from '~/core/i18n'

export const $eventsDetails = combine(i18n.$t, ({ t }) => ({
  liveTitle: t('live'),
  upcomingTitle: t('upcoming'),
  playButton: t('play'),
  popupDescriptionTitle: t('description'),
  daysTitleTimer: t('day_other'),
  hoursTitleTimer: t('hour_other'),
  minutesTitleTimer: t('minute_other'),
}))
